import React, { useState } from "react";
import PropTypes from "prop-types";
import { TransitionGroup, CSSTransition } from "react-transition-group";

import "./style.scss";
import { Notification, Delete } from "rbx";

const DisplayError = ({ error, toggleOpen }) => {
  if (!error || !error.message) return null;
  return error.networkError &&
    error.networkError.result &&
    error.networkError.result.errors.length ? (
    error.networkError.result.errors.map((error, i) => (
      <Notification color="danger" key={i}>
        <p data-test="graphql-error">
          <strong>Whoops!&nbsp;</strong>
          {error.message.replace(/GraphQL\serror:/g, "\n")}
        </p>
        <Delete as="button" onClick={() => toggleOpen(false)} />
      </Notification>
    ))
  ) : (
    <Notification color="danger">
      <p data-test="graphql-error">
        <strong>Tsk-Tsk!</strong>&nbsp;
        {error.message.replace(/GraphQL\serror:/g, "")}
      </p>
      <Delete as="button" onClick={() => toggleOpen(false)} />
    </Notification>
  );
};

DisplayError.propTypes = {
  error: PropTypes.object,
  toggleOpen: PropTypes.func
};

const ErrorMessage = ({ error }) => {
  console.log(error.graphQLErrors);
  const [open, setOpen] = useState(true);
  return (
    <div className="error-message-container" key="error">
      <TransitionGroup component={null}>
        {open && (
          <CSSTransition classNames="error" timeout={300}>
            <div className="error-message">
              <DisplayError error={error} toggleOpen={setOpen} />
            </div>
          </CSSTransition>
        )}
      </TransitionGroup>
    </div>
  );
};
ErrorMessage.propTypes = {
  error: PropTypes.object
};

ErrorMessage.defaultProps = {
  error: {}
};

export default ErrorMessage;
